import { render } from "./ModalOutboundItemsFormDetail.vue?vue&type=template&id=6cd3adb8"
import script from "./ModalOutboundItemsFormDetail.vue?vue&type=script&lang=js"
export * from "./ModalOutboundItemsFormDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__